import React from "react";
import { ArrowRight } from "lucide-react";
import { resolveImg } from "@/lib/api";
import { SectionHeading } from "@/pages/home/SectionHeading";

export const CollectionsSection = ({ collections, onSelect }) => (
  <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-16">
    <SectionHeading>Shop By Collection</SectionHeading>
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
      {collections.map((col, i) => (
        <button
          key={col.title || i}
          data-testid={`collection-tile-${(col.title || "collection").toLowerCase().replace(/\s+/g, "-")}`}
          onClick={() => onSelect(col)}
          className="group relative rounded-2xl overflow-hidden card-shadow-soft hover:card-shadow-hover transition-shadow duration-300 text-left aspect-[3/4]"
        >
          <img src={resolveImg(col.image)} alt={col.title} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
          <div className={`absolute inset-0 ${col.dark ? "bg-black/45" : "bg-gradient-to-t from-black/45 via-transparent to-transparent"}`} />
          <div className="absolute top-0 left-0 p-4">
            <div className="font-display text-white text-lg sm:text-xl leading-tight drop-shadow">{col.title}</div>
            <span className="inline-flex items-center gap-1 text-xs text-white/95 mt-1.5 group-hover:gap-2 transition-all duration-200">Shop Now <ArrowRight className="h-3 w-3" /></span>
          </div>
        </button>
      ))}
    </div>
  </section>
);
